import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from '../plugins/logger';

import SaveState from './modules/savestate';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        online: false
    },
    mutations: {
        setOnline(state, value) {
            state.online = value
        }
    },
    modules: {
        SaveState
    },
    plugins: process.env.NODE_ENV !== 'production'
        ? [createLogger()]
        : []
});
